import { Navigate, Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {jwtDecode} from "jwt-decode";

// Function to get the decoded JWT and extract the role
const getUserRole = () => {
  const token = localStorage.getItem("adminToken"); 
  if (token) {
    try {
      const decodedToken = jwtDecode(token); 
      return decodedToken.role; 
    } catch (err) {
      console.error("Failed to decode token:", err);
      return null;
    }
  }
  return null;
};

const AuthRoute = ({ roleRequired }) => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const role = getUserRole();
    if (role === "admin") {
      setLoading(false);
    } else {
      // Redirect to login if the user is not an admin
      navigate("/login");
    }
  }, [navigate]);

  if (loading) {
    return <div>Loading...</div>; 
  }

  return roleRequired === "admin" ? <Outlet /> : <Navigate to="/login" />;
};

export default AuthRoute;
